import React from "react";
import { Phone, Mail, MapPin, Clock, ArrowUpRight } from "lucide-react";

export default function Contact() {
  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="py-24 md:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12 items-start">
        <div className="lg:col-span-5">
          <div className="flex items-center gap-3 mb-4">
            <span className="inline-block w-10 h-px bg-[#FF5A1F]" />
            <span className="label-kicker text-[#FF5A1F]">Nous contacter</span>
          </div>
          <h2
            data-testid="contact-title"
            className="font-display font-extrabold text-4xl md:text-5xl lg:text-6xl tracking-tight text-[#0F172A] leading-[1]"
          >
            Parlons de votre chantier.
          </h2>
          <p className="mt-6 text-slate-600 leading-relaxed max-w-md">
            Un devis gratuit, une visite technique ou une urgence ?
            Appelez-nous ou envoyez-nous un email — nous vous répondons sous 24h.
          </p>
          <div className="mt-10 border-t border-slate-200 pt-6 flex items-start gap-3 text-sm text-slate-600">
            <Clock className="w-4 h-4 text-[#FF5A1F] mt-0.5 shrink-0" />
            <div className="font-display font-semibold tracking-tight leading-relaxed">
              Du lundi au vendredi
              <br />
              8h30 – 12h30 · 13h30 – 17h15
            </div>
          </div>
        </div>

        <div className="lg:col-span-7 grid sm:grid-cols-2 gap-0 border-l border-t border-slate-200">
          <a
            href="tel:0658116161"
            data-testid="contact-phone"
            className="group relative border-r border-b border-slate-200 p-8 lg:p-10 bg-[#003366] text-white hover:bg-[#002147] transition-colors"
          >
            <div className="flex items-start justify-between">
              <Phone className="w-6 h-6 text-[#FF5A1F]" />
              <ArrowUpRight className="w-5 h-5 opacity-60 group-hover:opacity-100 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition" />
            </div>
            <div className="label-kicker text-[#FF9A6F] mt-8">Téléphone</div>
            <div className="mt-2 font-display font-extrabold text-2xl md:text-3xl tracking-tight leading-tight">
              06 58 11 61 61
              <br />
              06 89 76 45 77
            </div>
            <div className="mt-3 text-sm text-slate-200/80">
              Appel direct, réponse immédiate.
            </div>
          </a>

          <a
            href="mailto:etancia.pro1@gmail.com"
            data-testid="contact-email"
            className="group relative border-r border-b border-slate-200 p-8 lg:p-10 bg-white hover:bg-[#F2F4F7] transition-colors"
          >
            <div className="flex items-start justify-between">
              <Mail className="w-6 h-6 text-[#FF5A1F]" />
              <ArrowUpRight className="w-5 h-5 text-slate-400 group-hover:text-[#FF5A1F] group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition" />
            </div>
            <div className="label-kicker text-slate-500 mt-8">Email</div>
            <div className="mt-2 font-display font-extrabold text-xl md:text-2xl tracking-tight text-[#0F172A] break-all">
              etancia.pro1@gmail.com
            </div>
            <div className="mt-3 text-sm text-slate-600">
              Envoyez-nous vos plans ou photos.
            </div>
          </a>

          <div
            data-testid="contact-zone"
            className="sm:col-span-2 relative border-r border-b border-slate-200 p-8 lg:p-10 bg-[#F2F4F7]"
          >
            <div className="flex items-start justify-between">
              <MapPin className="w-6 h-6 text-[#FF5A1F]" />
            </div>
            <div className="label-kicker text-slate-500 mt-8">
              Adresse & zone d'intervention
            </div>
            <div className="mt-2 font-display font-extrabold text-xl md:text-2xl tracking-tight text-[#0F172A]">
              Ris-Orangis 91130 · Île-de-France
            </div>
            <div className="mt-3 text-sm text-slate-600 max-w-lg">
              Paris · 92 · 93 · 94 · 95 · 78 · 91 · 77 — nos équipes se
              déplacent partout en région parisienne.
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
